/* jshint ignore:start */
import React, { Component } from "react";
// import SuggestSearch from "./SuggestSearch";

class SearchBar extends Component {
  state = {
    text: "",
  };

  onChangehandler = (event) => {
    if (event.which === 32 && !event.target.value) {
      event.preventDefault();
    } else {
      this.setState({ text: event.target.value });
      // this.props.change(event.target.value);
    }
  };

  onSubmitHandler = (event) => {
    event.preventDefault();
    this.props.onSearch(this.state.text);
  };

  render() {
    return (
      <div className="card">
        <div className="card-body" style={{ padding: "0.50rem" }}>
          <label>
            <b>Video Search</b>
          </label>
          <form onSubmit={this.onSubmitHandler}>
            <div className="input-group mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Search in V$Clip"
                onKeyPress={this.onChangehandler}
              />
            </div>
          </form>
        </div>
        {/* {this.props.onSuggest.map(sug => {
          return (
              <SuggestSearch key={sug.id.videoId} suggest={sug.snippet} />
            
          );
        })} */}
              
      </div>
    );
  }
}

export default SearchBar;
